// eslint-disable-next-line complexity
export const getRelatedItemAlt = ({
  brandName,
  itemName,
  categoryName,
}: {
  brandName: string | null
  itemName: string
  categoryName?: string
}): string => {
  // 何も指定がない場合: 空文字列
  if (!brandName && !itemName && !categoryName) return ''
  // ブランド名のみの場合: 「ブランド名」
  if (brandName && !itemName && !categoryName) return brandName
  // アイテム名のみの場合: 「アイテム名」
  if (!brandName && itemName && !categoryName) return itemName
  // カテゴリ名のみの場合: 「カテゴリ名」
  if (!brandName && !itemName && categoryName) return categoryName
  // ブランド名とアイテム名: 「ブランド名 | アイテム名」
  if (brandName && itemName && !categoryName)
    return `${brandName} | ${itemName}`
  // ブランド名とカテゴリ名: 「ブランド名 | カテゴリ名」
  if (brandName && !itemName && categoryName)
    return `${brandName} | ${categoryName}`
  // アイテムとカテゴリ名: 「アイテム名(カテゴリ名)」
  if (!brandName && itemName && categoryName)
    return `${itemName}(${categoryName})`
  // ぜんぶ
  return `${brandName} | ${itemName}(${categoryName})`
}
